import React, { useEffect, useState, useRef } from 'react'
import {
  Calendar,
  Server,
  Settings,
  FileText,
  Users,
  BookOpen,
  Tool,
  CheckCircle,
  Folder,
  Sun,
  User
} from 'react-feather'
import { Link, NavLink, useLocation, matchPath } from 'react-router-dom'
import { InstructorProfileBg, User15 } from '../../imagepath'
import StickyBox from 'react-sticky-box'
import { signOut } from '../../../lib/auth'
import { getFile } from '../../../lib/file'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../usercontext'
import { Activity } from 'feather-icons-react/build/IconComponents'

// eslint-disable-next-line react/prop-types
export default function InstructorSidebar({ activeMenu, setMobileMenu }) {
  const [studentName, setStudentName] = useState('')
  const [nickName, setNickName] = useState('')
  const [avatar, setAvatar] = useState('')
  const { profile } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const sidebarRef = useRef(null)

  console.log('path', pathname.slice(0, pathname.lastIndexOf('/')))

  const setNavlinkClasses = (paths) => {
    paths.map((path) => pathname.includes(path)) //matchPath(path, pathname))
      ? 'nav-item active'
      : 'nav-item'
  }

  //isActive={() => ['/events', '/myevents'].includes(pathname)} >
  let isActive = (paths) => paths.includes(pathname)

  //console.log("path",pathname.includes(path));
  //https://dev.to/kiranmantha/how-to-set-active-class-on-navlink-for-multiple-react-routes-3n9i
  /*
if(pathname.includes(path))
  return "nav-item active";
else  return "nav-item";

})
*/

  //console.log("pathname",isActive(["/admin/admin-studentdetail","anvv","saamdlam"]));

  const handleSignOut = async (e) => {
    const error = await signOut()

    navigate('/login')
  }

  async function GetData() {
    //console.log("SideBarAvatar",profile);

    if (profile) {
      setStudentName(profile.name + ' ' + profile.surname)
      setNickName(profile.username)
      const avt = await getFile(profile.avatar_url)
      setAvatar(avt.publicUrl)
    }
  }

  useEffect(() => {
    GetData()
  }, [profile])

  const hideMobileMenu = () => {
    document.body.classList.remove('menu-opened')
    setMobileMenu(false)
  }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        document.body.classList.remove('menu-opened')
        setMobileMenu(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [setMobileMenu])
  return (
    /*  <div className='col-xl-2 col-lg-3 col-md-12 theiaStickySidebar instructorSidebar'> */
    <div className='theiaStickySidebar instructorSidebar' ref={sidebarRef}>
      <StickyBox offsetTop={20} offsetBottom={20}>
        <div className='sideStickyBar'>
          <div className='settings-widget dash-profile'>
            <div className='settings-menu p-0'>
              <div className='profile-bg'>
                <h5 onClick={hideMobileMenu} style={{ cursor: 'pointer' }}></h5>
                <img src={InstructorProfileBg} alt='' />
                <div className='profile-img'>
                  <Link to='/instructor/'>
                    <img src={avatar ? avatar : User15} alt='' />
                  </Link>
                </div>
              </div>
              <div className='profile-group'>
                <div className='profile-name text-center'>
                  <h4>
                    <Link to='/instructor/'>{studentName}</Link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className='settings-widget account-settings feather-icon'>
            <div className='settings-menu'>
              <ul>
               
                <li>
                  <Link to='/instructor/instructor-class'>
                    <Activity size={20} /> Class List
                  </Link>
                </li>
                <li>
                  <Link to='/instructor/instructor-scheduledays'>
                    <Calendar size={20} /> Schedule
                  </Link>
                </li>
                <li>
                  <Link to='/instructor/instructor-desiredcolleges'>
                    <BookOpen size={20} /> College List
                  </Link>
                </li>
              
                
                <li>
                  <Link to='/instructor/instructor-taskmanage'>
                    <Server size={20} />
                    Agenda
                  </Link>
                </li>
                <li>
                  <Link to='/instructor/instructor-profile'>
                    <User size={20} /> Edit Profile
                  </Link>
                </li>
                <li>
                  <Link to='/instructor/instructor-notes'>
                    <FileText size={20} />
                    Notes
                  </Link>
                </li>
              </ul>
              {/*    <ul> */}
              {/*}
              <li className="nav-item">
                {/*
                 <Link
                  to="/admin"
                  className={
                    activeMenu === "Dashboard" ? "nav-item active" : "nav-item"
                  }
                >
                  <Home size={20} /> My Dashboard
                </Link>
                
                <NavLink to="/instructor">
                  <Settings size={20} /> Edit Profile
              </NavLink>
              </li>
              */}
              {/*    <li className="nav-item">
                <NavLink to="/instructor/instructor-taskmanage">
                  <Server size={20} /> Tasks
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/instructor/instructor-class">
                  <Folder size={20} /> Class
                </NavLink>
              </li> */}
              {/*}
              <li className="nav-item" >
                <NavLink to="/admin/admin-student-grid"
                className={isActive(['/admin/admin-student-grid', '/admin/admin-studentedit','/admin/admin-studentdetail'])}>
                  <Users size={20} /> Students
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/admin-instructor-list">
                  <Sun size={20} /> Instructors
                </NavLink>
              </li>
              */}
              {/*       <li className="nav-item">
                <NavLink to="/instructor/instructor-notes">
                  <FileText size={20} /> Notes
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={handleSignOut} className="nav-link">
                  <Power size={20} /> Sign Out
                </NavLink>
              </li>
            </ul> */}
              {/*}
            <div className="instructor-title">
              <h3>SETTINGS</h3>
            </div>
            <ul>
              <li className="nav-item">
                <NavLink to="/admin/admin-params">
                  <Tool size={20} /> Parameters
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/admin-booklist" >
                  <BookOpen size={20} /> BookList
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/admin-appcheck">
                  <CheckCircle size={20} /> Application Check
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/admin-desiredcolleges">
                  <User size={20} /> Desired Colleges
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/admin-lessons">
                  <RefreshCw size={20} /> Lessons
                </NavLink>
              </li>
            </ul>
            */}
            </div>
          </div>
        </div>
      </StickyBox>
    </div>
  )
}
